module.exports = __webpack_public_path__ + "static/media/LogoDark.defdc748.svg";